export default __webpack_public_path__ + "static/media/showroom41.e805a46c.webp";